﻿import datePicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(datePicker.locales, nl);

document.addEventListener('DOMContentLoaded', () => {
    const $datepickers = document.querySelectorAll('.umbraco-forms-field input.datepickerfield');
    if (typeof $datepickers.length) {
        let datepickerInstance = [];
        var options = {
            autohide: true,
            format: 'dd-mm-yyyy',
            language: 'nl',
            nextArrow: '>',
            prevArrow: '<',
            orientation: 'bottom'
        }
        $datepickers.forEach(($datepicker, i) => {
            datepickerInstance[i] = new Datepicker($datepicker, options);
            $datepicker.addEventListener('changeDate', (event) => {
                document.getElementById(event.target.id.replace("_1", "")).value = event.detail.date;
            });
        });
    }
});